import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/Calculator";
import AlbumWizard from "@/pages/AlbumWizard";
import Admin from "@/pages/Admin";
import CoupleAlbum from "@/pages/CoupleAlbum";
import { GuestHome, GuestGallery } from "@/pages/GuestAlbum";
import BerkasClient from "@/pages/BerkasClient";
import AlbumKustom from "@/pages/AlbumKostum";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/builder" element={<Calculator />} />
        <Route path="/album/buat" element={<AlbumWizard />} />
        <Route path="/a/:id" element={<GuestHome />} />
        <Route path="/a/:id/album" element={<GuestGallery />} />
        <Route path="/kelola/:id" element={<CoupleAlbum />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/berkas" element={<BerkasClient />} />
        <Route path="/album/custom" element={<AlbumKustom />} />
      </Routes>
    </BrowserRouter>
  );
}
